import script from "./ShopInventory.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShopInventory.vue?vue&type=script&setup=true&lang=ts"

import "./ShopInventory.vue?vue&type=style&index=0&id=247b61d2&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-247b61d2"]])

export default __exports__